// Layout.js
import React, { useState } from "react";
import { HashRouter } from "react-router-dom";
import classNames from "classnames";
import { useSelector } from "react-redux";
import SideNav from "../components/SideNav";
import Main from "../routes/AppRoute";
import { loginSelector } from "../redux/slices/loginSlice";
import { dashboardSelector } from "../redux/slices/dashboardSlice";
import ToolBar from "../components/ToolBar";
import AppRoute from "../routes/AppRoute";

const Layout = () => {
  const loginStore = useSelector(loginSelector);
  const dashboardState = useSelector(dashboardSelector);
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
  return (
    <HashRouter>
      <div className="flex" style={{ background: "#ECF0F5" , width:"100%", height: '100%' }}>
        {loginStore.status === "authenticated" ? (
          <div style={{display:"flex",width:"100%", height: '100%'}}>
            <div className={`${
              isSidebarOpen
            }`}>
              
            <SideNav 
              isOpen={isSidebarOpen}
              toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
            />
            </div>
            <div
              style={{ width: "100%", padding:'0 24px', height: '100%', overflow:'auto' }}
            >
              <AppRoute />
            </div>
          </div>
        ) : (
          <AppRoute />
        )}
      </div>
    </HashRouter>
  );
};

export default Layout;
